import React from 'react'
import { Card, Col, Collapse, OverlayTrigger, Row, Tooltip, TooltipProps } from 'react-bootstrap'
import { ChevronDown, ChevronUp, Info } from 'react-feather'

interface SettingsCardProps {
	title: string
	subtitle?: string
	helpLink?: string
	startsCollapsed?: boolean
	collapsibleElement: JSX.Element
}

const SettingsCard = (props: SettingsCardProps) => {
	const [isCollapsed, setIsCollapsed] = React.useState<boolean>(props.startsCollapsed !== undefined ? props.startsCollapsed : true)

	return (
		<Card className="subsync-card">
			<Card.Header>
				<Row onClick={() => setIsCollapsed(!isCollapsed)}>
					<Col sm="auto">
						<h3>{props.title}</h3>
						{props.subtitle && <sub>{props.subtitle}</sub>}
					</Col>
					<Col sm="auto">
						{props.helpLink && (
							<OverlayTrigger
								placement="top"
								overlay={<Tooltip id={'tooltip-help-link-' + props.title.replace(' ', '-')}>{props.title + ' Help'}</Tooltip>}
							>
								<a href={props.helpLink} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>
									<Info />
								</a>
							</OverlayTrigger>
						)}
					</Col>
					<Col />
					<Col sm="auto">
						{isCollapsed ? (
							<ChevronDown onClick={() => setIsCollapsed(!isCollapsed)} />
						) : (
							<ChevronUp onClick={() => setIsCollapsed(!isCollapsed)} />
						)}
					</Col>
				</Row>
			</Card.Header>
			<Collapse in={!isCollapsed}>
				<Card.Body>{props.collapsibleElement}</Card.Body>
			</Collapse>
		</Card>
	)
}

export default SettingsCard
